import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL ?? '';
const API_USERNAME = process.env.REACT_APP_API_USERNAME ?? '';
const API_PASSWORD = process.env.REACT_APP_API_PASSWORD ?? '';

// Basic authentication header
const authHeader = {
  auth: {
    username: API_USERNAME,
    password: API_PASSWORD
  }
};

// Update the focus keyphrase using the focus-keyphrase endpoint
export const updateFocusKeyphrase = async (keyphrase: string, postId: number) => {
  try {
    await axios.put(`${API_URL}/wordpress-posts/${postId}/focus-keyphrase`, { keyphrase }, authHeader);
  } catch (error) {
    console.error(error);
    throw new Error("Error updating focus keyphrase");
  }
};

export const updateSlug = async (slug: string, postId: number) => {
  try {
    await axios.put(`${API_URL}/wordpress-posts/${postId}/slug`, { slug }, authHeader);
  } catch (error) {
    console.error(error);
    throw new Error("Error updating slug");
  }
};


export const updateTitle = async (newTitle: string, postId: number) => {
  try {
    await axios.put(`${API_URL}/wordpress-posts/${postId}/title`, { title: newTitle }, authHeader);
  } catch (error) {
    console.error(error);
    throw new Error("Error updating title");
  }
};

export const updateMeta = async (newMetaDescription: string, postId: number) => {
  try {
    await axios.put(`${API_URL}/wordpress-posts/${postId}/meta-description`, { description: newMetaDescription }, authHeader);
  } catch (error) {
    console.error(error);
    throw new Error("Error updating meta description");
  }
};


export const duplicatePost = async (postId: number): Promise<number | undefined> => {
  try {
    const response = await axios.post<{ new_post_id: number }>(`${API_URL}/wordpress-posts/${postId}/duplicate`, {}, authHeader);
    return response.data.new_post_id;
  } catch (error) {
    console.error(error);
    throw new Error("Error duplicating post");
  }
};

export const updateContent = async (needle: string, newValue: string, postId: number) => {
  try {
    await axios.put(`${API_URL}/wordpress-posts/${postId}/beaver-data`, { needle, new_value: newValue }, authHeader);
  } catch (error) {
    console.error(error);
    throw new Error("Error updating content");
  }
};
